"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVICE_CATALOGS_ENUM_TYPES = exports.SERVICE_CATALOGS = exports.NAMESPACE = void 0;
var NAMESPACE = 'services';
exports.NAMESPACE = NAMESPACE;
var SERVICE_CATALOGS = ['discovery', 'limited', 'signin', 'postauth', 'custom'];
exports.SERVICE_CATALOGS = SERVICE_CATALOGS;
var SERVICE_CATALOGS_ENUM_TYPES = {
  STRING: 'SERVICE_CATALOGS_ENUM_TYPES_STRING',
  NUMBER: 'SERVICE_CATALOGS_ENUM_TYPES_NUMBER'
};
exports.SERVICE_CATALOGS_ENUM_TYPES = SERVICE_CATALOGS_ENUM_TYPES;
//# sourceMappingURL=constants.js.map
